import React from 'react';
import PropTypes from 'prop-types';
import { Radios } from '@ontruck/orc';

const TypeOfOrderSelector = ({
  options,
  typeOfOrder,
  handleChangeType,
  className,
}) => (
  <div className={className}>
    <Radios
      girded
      size="L"
      name="type"
      value={typeOfOrder}
      items={options}
      onChange={handleChangeType}
    />
  </div>
);

TypeOfOrderSelector.propTypes = {
  options: PropTypes.arrayOf(PropTypes.object),
  className: PropTypes.string,
  typeOfOrder: PropTypes.string,

  handleChangeType: PropTypes.func,
};

TypeOfOrderSelector.defaultProps = {
  options: [],
  className: '',
  typeOfOrder: '',
};

export default TypeOfOrderSelector;
